module.exports = __webpack_public_path__ + "media/images/weather/266_night-961830fb1464cbb4997a1db3584cc05e.png";